import React, { useContext, useMemo } from 'react';
import ToggleButton, { toggleButtonClasses } from '@mui/material/ToggleButton';
import ToggleButtonGroup, {
  toggleButtonGroupClasses,
} from '@mui/material/ToggleButtonGroup';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import { ThemeContext } from './theme-toggler/theme-context';

const ww = 130;
const pp = 16;

const StyledToggleButtonGroup = styled(ToggleButtonGroup, {
  shouldForwardProp: (prop) => !["noScale", "alignleft", "alignLeftSize", "count", "maxWidth"].includes(prop),
})(({count, noScale,alignleft = false , alignLeftSize=false, maxWidth=false}) => ({
  marginTop:"4px",
  position:"absolute",
  height:"32px",
  minWidth:maxWidth?maxWidth:1822,
  maxHeight:"32px",
  ...(alignleft == "true" ? {
    transform:noScale?"scale(1)":"scale(0.90)",
    transformOrigin:"left center",
    marginLeft:"12px"} :
    alignLeftSize?
    {
      marginLeft:`max(280px, calc( (50vw - ${alignLeftSize}px) - ${(ww*count)/4}px))`
      
    }:
    {
      marginLeft:count>2?`max(380px, calc( (50vw - 107px) - ${(ww*count)/2}px))`:`max(280px, calc( (50vw - 164px) - ${(ww*count)/4}px))`
    }),
  fontSize:"14px",
  [`& .${toggleButtonGroupClasses.firstButton}, & .${toggleButtonGroupClasses.middleButton}`]:
    {
      paddingTop:`${pp}px !important`,
      paddingBottom:`${pp}px !important`,
      width: `auto`,
      minWidth:"100px",
      fontSize:"14px",
    },
  [`& .${toggleButtonGroupClasses.lastButton}, & .${toggleButtonGroupClasses.middleButton}`]:
    {
      minWidth:"100px",
      paddingTop:`${pp}px !important`,
      paddingBottom:`${pp}px !important`,
      fontSize:"14px",
      width: `auto`,
    },
  [`& .${toggleButtonGroupClasses.lastButton}.${toggleButtonClasses.disabled}, & .${toggleButtonGroupClasses.middleButton}.${toggleButtonClasses.disabled}`]:
    {
      minWidth:"100px",
      paddingTop:`${pp}px !important`,
      paddingBottom:`${pp}px !important`,
      width: `auto`,
      fontSize:"14px",
    },
}));

export default function HorizontalMenu({
  isDark,
  maxWidth=false,
  noScale=false,
  bgColor,
  textColor="rgba(0,0,0,0.86)",
  alignLeftSize = false,
  alignleft,
  addLabel = true,
  menuCounts =[],
  menuCountStyle = [],
  menuDisabled = [],
  children,value, setValue, onChangeValue,
  menuItems = [
    "Applications",
    "Traceability",
    "Cloud suitability",
    "Graviton Readiness",
    ".NET Modernization"
  ],
  menuValues = [
    "apps",
    "traceability",
    "assess",
    "graviton",
    "dotnetmodernization"
  ]
} ) {

  const { theme } = useContext(ThemeContext);
  const menuTheme = useMemo(() => createTheme({ palette: { mode: isDark ? "dark" : (theme === "dark" ? "dark" : "light") } }), [theme]);

  const mnuMap = {
    [menuValues[0]]:menuItems[0],
    [menuValues[1]]:menuItems[1],
    ...(menuValues[2]?{[menuValues[2]]:menuItems[2]}:{}),
    ...(menuValues[3]?{[menuValues[3]]:menuItems[3]}:{}),
    ...(menuValues[4]?{[menuValues[4]]:menuItems[4]}:{})

  }

const alignmentValues = menuItems.map((m,i) => ({
  [m]: i==0?"left aligned":i==1?"centered":i==2?"right aligned":i==3?"justified":"justified"
}))
  return (
    <ThemeProvider theme={menuTheme}>
    {addLabel && <div
      className={`horizontalMenu`}
      style={{
        fontSize:"18px",
        marginLeft:"10px",
        marginRight:"20px",
        marginTop:"8px",
        minWidth:"180px",
        ...(maxWidth?{maxWidth:maxWidth}:{})
      }}
      >{mnuMap[value]}</div>
    }
    {children}
    <StyledToggleButtonGroup
      maxWidth={maxWidth}
      noScale={noScale}
      alignLeftSize={alignLeftSize}
      alignleft={`${alignleft?alignleft:false}`}
      count={menuItems.length}
      value={value}
      exclusive
      onChange={onChangeValue}
      aria-label="applicationTypeMen"
    >
      {menuItems.map((item, index) => (
        <ToggleButton 
        style={
          {...(bgColor?
            {
              backgroundColor: bgColor,
              color: textColor,
              opacity: 1
            }
            :{})}
        }
        className={`toggleButton ${menuValues[index] == value ?"active":"" }`} key={index} value={menuValues[index]} aria-label={`${ alignmentValues[item] }`} disabled={!!menuDisabled[index]}>
          <div 
          
          >{item}
            {menuCounts[index]>0 && <div style={{ 
              marginLeft:"6px",
              display:"inline-block",
              background:menuCountStyle[index] == 0 ? "transoarent" : "rgb(var(--color-sorting-tables))",
              color: "white",
              borderRadius:"4px",
              fontFamily: "InterBlack",
              // marginTop:8,
              paddingTop: "0px",
              paddingLeft: "6px",
              paddingRight: "6px",
              transform:"scale(0.7)"
            }}>{menuCounts[index]>0 ? ` ${menuCounts[index]} ` : ""}</div>}
            </div>
        </ToggleButton>
      ))}

    </StyledToggleButtonGroup>
    </ThemeProvider>
  );
}
